var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 47,
    viewBox: "0 0 52 47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5391 9.53571C12.7969 9.53571 10.6641 11.7946 10.6641 14.4643C10.6641 17.2366 12.7969 19.3929 15.5391 19.3929C18.1797 19.3929 20.4141 17.2366 20.4141 14.4643C20.4141 11.7946 18.1797 9.53571 15.5391 9.53571ZM45.5 0.5H6.5C2.94531 0.5 0 3.47768 0 7.07143V39.9286C0 43.625 2.94531 46.5 6.5 46.5H45.5C49.0547 46.5 52 43.625 52 39.9286V7.07143C52 3.47768 49.1562 0.5 45.5 0.5ZM47.125 39.3125L33.2109 20.2143C32.9062 19.7009 32.3984 19.3929 31.7891 19.3929C31.0781 19.3929 30.5703 19.7009 30.1641 20.2143L19.3984 35L15.6406 30.2768C15.2344 29.8661 14.7266 29.558 14.1172 29.558C13.5078 29.558 13 29.8661 12.5938 30.2768L4.97656 39.9286L4.875 7.07143C4.875 6.25 5.6875 5.42857 6.5 5.42857H45.5C46.4141 5.42857 47.125 6.25 47.125 7.07143V39.3125Z",
    fill: "#B7C3C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/ImagePlaceholder.159c914d67c8d52c1b74a49e0c2db03b.svg";
export { ForwardRef as ReactComponent };